import React , {useEffect,useState,useContext } from 'react';
import { useDebounceEffect } from '../../../hooks';
import Box from '@material-ui/core/Box';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import {EmailTooltip,SearchBar} from '../../atoms/index'
import './report-tab-listing.scss';
import { default as t } from '../../../utils/i18n';
import { ReportTable } from '../../atoms';
import { DashService } from '../../../services';
import { UserContext } from '../../../context';

const ReporttabListing = props => {
  const [tabValue, setTabValue] = useState("1");
  const [searchKeyword, setSearchKeyword] = useState('');
  const [filterBy, setFilterBy] = useState(null);
  const [reportData, setReports] = React.useState([]);
  const [sharedReportData, setSharedReportData] = React.useState([]);
  const { user } = useContext(UserContext);
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;
  const authenticated = user?.authenticated;
  const [dropdownFilterby, setDropdownFilterby] = useState(0);
  const filterOption = [['report_id','nickname','advertiser','industry','country','kpi','status'],['report_id'],
  ['nickname'],
  ['advertiser'],
  ['industry'],
  ['country'],
  ['kpi'],
  ['status']
];
const options = [
  { value: 0, label: t('reportTable.text.all') },
  { value: 1, label: t('reportTable.text.reportId') },
  { value: 2, label: t('reportTable.text.nickName') },
  { value: 3, label: t('reportTable.text.advertiser') },
  { value: 4, label: t('reportTable.text.industry') },
  { value: 5, label: t('reportTable.text.country') },
  { value: 6, label: t('reportTable.text.kpi') },
  { value: 7, label: t('reportTable.text.status') },
];
  const handleChange = (event, newValue) => {
    setTabValue(Number(newValue));
    handleDropdownOnChange(options[0]);
    handleSearchOnChange('');
    if(Number(newValue) === 1) {
      getReports();
    } else {
     // getSharedReports();
    }
   
  };
const onTableUpdate = (event) => {
  if(event) {
    getReports();
  }
}

const onRowClicked = (event) => {
  if(event) {
    props.onTableRowclicked(event);
  }
}
const getReports = async() => {
  //console.log(dropdownFilterby,"dropdownFilterby");
    try {
      const reportListResponse = await DashService.getReports(userAccessToken, username,filterOption[dropdownFilterby],searchKeyword);
      //console.log('reportListResponse::', reportListResponse);
      const reportData = reportListResponse?.data?.data?.list;
      //console.log('reportData11::', reportData);
      setReports(reportData);
    } catch (error) {
      console.log(
        '\x1b[31m[Error]',
        '~File:report-tab-listing.jsx~',
        '==> Error Get reports ==>',
        null,
        '\x1b[0m'
      ); //debug
      setReports([]);
    }
  }


const getSharedReports = async() => {
  try {
    const reportListResponse = await DashService.getSharedReports(userAccessToken, username,filterOption[dropdownFilterby],searchKeyword);
    //console.log('reportListResponse::', reportListResponse);
    const sharedReports = reportListResponse?.data?.data?.list;
    //console.log('sharedReports11::', sharedReports);
    setSharedReportData(sharedReports);
  } catch (error) {
    console.log(
      '\x1b[31m[Error]',
      '~File:report-tab-listing.jsx~',
      '==> Error Get reports ==>',
      null,
      '\x1b[0m'
    ); //debug
    setSharedReportData([]);
  }
}



    useEffect(() => {
      //console.log(options[0].value,'options[0].value');
      setFilterBy(options[0]);
      if (authenticated) {
         getReports();
      }
    }, []);

    useEffect(() => {
       if (authenticated) {
         getReports();
      }
    }, [props.onUpdateTable]);

    useEffect(() => {
      const searchText = searchKeyword.trim();
      //console.log(searchText,'searchText');
       if (dropdownFilterby !== null) {
        if(Number(tabValue) === 1) {
          getReports();
        } else {
         // getSharedReports();
        }
      }
    }, [dropdownFilterby]);


    useDebounceEffect(
      () => {
        const searchText = searchKeyword.trim();
         if (dropdownFilterby !== null) {
          if(Number(tabValue) === 1) {
            getReports();
          } else {
            getSharedReports();
          }
        }
      },
      500,
      [searchKeyword]
    );
    const handleSearchOnChange = searchText => {
      setSearchKeyword(searchText);
    };
    const handleDropdownOnChange = dropdwnVal =>{
      //console.log(dropdwnVal);
      setFilterBy(dropdwnVal);
      setDropdownFilterby(dropdwnVal.value);
    }
  return (
    <div className='listing-container'>
      <SearchBar onChange={handleSearchOnChange} value={searchKeyword} onDropdownChange={handleDropdownOnChange} options={options} filterBy={filterBy}/>
         <Box sx={{ width: '100%', typography: 'body1' }}>      
      <TabContext value={(tabValue).toString()}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label={t('insights.report.list.heading')}>
            <Tab 
             label={
              <React.Fragment>
                <span className='text'>{t('insights.report.list.tab1.label')} </span>
                <span>({reportData?.length})</span>
                <EmailTooltip emailToolTip={t('reports.tooltip')} />
              </React.Fragment>
            }value="1" />
            <Tab className='hidden' label={
              <React.Fragment>
                <span className='text'>{t('insights.report.list.tab2.label')} </span>
                <span>({sharedReportData?.length})</span>
                <EmailTooltip emailToolTip={t('reports.tooltip')} />
              </React.Fragment>
            } value="2" />
          </TabList>
           
        </Box>
        <TabPanel value="1">
        <ReportTable reportData={reportData} onTableUpdate={onTableUpdate} onRowClicked = {onRowClicked}/>
          </TabPanel>
        <TabPanel className='hidden' value="2">
        <ReportTable reportData={sharedReportData} onTableUpdate={onTableUpdate} onRowClicked = {onRowClicked}/>
        </TabPanel>
       </TabContext>
    </Box>
     </div>
  );
};

export default ReporttabListing;
